import { Box, Button, Paper, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import StorySelectModal from '../StorySelectModal';
import { IStory } from '../../services/types';
import StoryList from '../StoryList';
import { GeoIndicator } from '../GeoIndicator';

interface IProps {
  stories: IStory[];
  readonly: boolean;
  availableCountryCountText?: string;
  onAddStory?: (story: IStory) => void;
  onChangeStoryGenreText?: (story: IStory, text: string) => void;
  onClickRemove?: (story: IStory) => void;
  onSortEnd?: (newIndex: number, oldIndex: number) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(3),
  },
  contentSettingWrap: {
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(3),
    padding: theme.spacing(3),
  },
  addStoriesWrap: {
    display: 'block',
    textAlign: 'right',
    marginBottom: '12px',
  },
  noStoryWrap: {
    height: '418px',
    border: '1px solid #e8e8e8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  storiesWrap: {
    maxHeight: '1335px',
    overflowY: 'scroll',
    border: '1px solid #e8e8e8',
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
    },

    '&::-webkit-scrollbar:vertical': {
      width: '8px',
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      border: '0 none',
      backgroundColor: 'rgba(0, 0, 0, .6)',
    },
  },
}));

export const ScrollableStoryListView = (props: IProps): JSX.Element => {
  const classes = useStyles();

  const [isStoryModalOpen, setIsStoryModalOpen] = useState<boolean>(false);
  const { stories } = props;

  useEffect(() => {
    if (props.stories.length === 0 && isStoryModalOpen) {
      setIsStoryModalOpen(false);
    }
  }, [props.stories]);

  return (
    <div>
      <Paper className={classes.contentSettingWrap}>
        <Box>
          <Typography variant="h6" component="h3">
            Stories {stories && stories.length > 0 && <span>({stories.length})</span>}
            {props.readonly && <GeoIndicator text={props.availableCountryCountText} />}
          </Typography>
          <Box className={classes.addStoriesWrap}>
            {!props.readonly && (
              // <a
              //   href="#"
              //   onClick={e => {
              //     e.preventDefault();
              //     setIsStoryModalOpen(true);
              //   }}
              // >
              //   Add Stories
              // </a>
              <Button onClick={() => setIsStoryModalOpen(true)} size="small" color="primary">
                Add stories
              </Button>
            )}
          </Box>
          {(!stories || stories.length === 0) && (
            <Box className={classes.noStoryWrap}>{props.readonly ? 'No Stories' : "Press the 'Add stories' button to add a story."}</Box>
          )}
          {stories && stories.length > 0 && (
            <StoryList
              hideSearch={true}
              stories={stories}
              className={classes.storiesWrap}
              additionalInfo={true}
              readonly={props.readonly}
              sortable={true}
              removable={true}
              onRemoveClick={story => {
                props.onClickRemove && props.onClickRemove(story);
              }}
              onStoryGenreTextChange={(story, text) => {
                props.onChangeStoryGenreText && props.onChangeStoryGenreText(story, text);
              }}
              onSortEnd={props.onSortEnd}
            />
          )}
        </Box>
      </Paper>
      <StorySelectModal
        title="Add Stories"
        open={isStoryModalOpen}
        onClick={(story: IStory) => {
          if (stories.find(s => s.id === story.id && s.seasonId === story.seasonId)) {
            return;
          } else {
            props.onAddStory && props.onAddStory(story);
          }
        }}
        onClose={() => setIsStoryModalOpen(false)}
      />
    </div>
  );
};
